/**
 * timeline Bullets Animation on Viewport
 */
function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

function loopItems() {
    const listItems = document.querySelectorAll('.timeline__item');

    listItems.forEach((item, index) => {
        let checkIfShowed = [];
        checkIfShowed[index] = 'false';

        document.addEventListener('scroll', enterAnimation, {
            passive: true
        });

        function enterAnimation() {
            const itemAnim = isInViewport(item) ? ('in ' + index, item.classList.add('timeline__item--animBullet'), checkIfShowed[index] = 'true') : ('out ' + index);

            // console.log(itemAnim);
            if (!checkIfShowed.includes('false')) {
                document.removeEventListener('scroll', enterAnimation)
            }
        }
    })
};

loopItems();

/**
 * If sc_timeline.timelineLayout_options.selected == 'Carousel'
 */
const timelineList = $('#timelineList');

if(timelineList.length) {
    $(timelineList).slick({
        slidesToShow: 1,
        dots: false,
        arrows: false,
        speed: 300,
        centerMode: true,
        centerPadding: '120px',
        adaptiveHeight: true,
        infinite: false,
        responsive: [
            {
              breakpoint: 480,
              settings: {
                centerPadding: '20vw',
              }
            }
          ]
    });
}